import type { SurfaceMutationResult } from "../surfaces/registry.js";

export type MutationSummary = {
  name: string;
  state: "updated" | "unchanged";
  message: string;
};

export function summarizeMutationResults(
  results: SurfaceMutationResult[],
): MutationSummary[] {
  return results.map((result) => ({
    name: result.name,
    state: result.changed ? "updated" : "unchanged",
    message: result.message,
  }));
}
